import React from "react";

const TempleGridStatue = () => {
  return <div>TempleGridStatue</div>;
};

export default TempleGridStatue;
